import { getPageMetadata } from './page-metadata';
import type { AnyRouter } from '@tanstack/react-router';
import type { i18n } from 'i18next';

/** Register before analytics so both the initial hit and navigation use the new title. */
export function initializePageMetadata(
  router: AnyRouter,
  translations: i18n,
  initialPath = location.pathname,
): () => void {
  let pathname = initialPath;
  const update = () => {
    const meta = getPageMetadata(pathname, translations.resolvedLanguage);
    document.documentElement.lang = meta.language;
    document.title = meta.title;
    for (const [attribute, key, content] of [
      ['name', 'description', meta.description],
      ['property', 'og:title', meta.title],
      ['property', 'og:description', meta.description],
      ['property', 'og:locale', meta.ogLocale],
    ] as const) {
      document.head.querySelector(`meta[${attribute}="${key}"]`)?.setAttribute('content', content);
    }
    // `noindex` страницы точки приходит в её статическом HTML; после перехода с
    // неё на главную он не должен оставаться в документе — и наоборот.
    let robots = document.head.querySelector('meta[name="robots"]');
    if (meta.indexable) {
      robots?.remove();
    } else if (robots === null) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      robots.setAttribute('content', 'noindex');
      document.head.append(robots);
    }
  };

  update();
  translations.on('languageChanged', update);
  const unsubscribe = router.subscribe('onResolved', ({ toLocation }) => {
    pathname = toLocation.pathname;
    update();
  });
  return () => {
    unsubscribe();
    translations.off('languageChanged', update);
  };
}
